export const booleanFilterOptions = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
];

export const auditFilterFields = [
  {
    type: "datetime-range",
    label: "Created Range",
    fromName: "created_at_from",
    toName: "created_at_to",
  },
  {
    type: "datetime-range",
    label: "Updated Range",
    fromName: "updated_at_from",
    toName: "updated_at_to",
  },
];

export const withAuditFilters = (fields = []) => [
  ...auditFilterFields,
  ...fields,
];
